@if (icon || loading) {
<span
    porIcon
    [icon]="loading ? 'spinner' : icon"
    [height]="16"
    [width]="16"
    [ngClass]="{
        'h-5': !iconOnly,
        'order-1': iconPos === 'after',
        'ml-xs': !iconOnly && !loading && iconPos === 'after',
        'mr-xs': !iconOnly && !loading && iconPos === 'before',
        'animate-spin': loading
    }"></span>
}

<ng-content></ng-content>
